const mimeTypes = ["text/plain"];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "" && ext === "txt") {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "text/plain";
}